import axios from 'axios';

import { SearchRequest } from 'core/util/Search';

interface Address {
    streetAddress: string;
    streetAddress2: string;
    region: string;
    postalCode: string;
    country: string;
    locality: string;
    timezone?: string;
}

interface EmailFrom {
    email: string;
}

export interface Attribute {
    name: string;
    value: string;
}

export interface Location {
    internalName: string;
    publicName: string;
    uid?: number;
    id?: string;
    code?: string;
    web?: string;
    address: Address;
    emailFrom?: EmailFrom;
    phone?: string;
    manager?: string;
    managerEmail?: string;
    attributes?: Attribute[];
    moduleSources?: Record<string, string[]>;
    moduleIDs?: string[];
}

export enum FieldName {
    InternalName = '__location_internal_name__',
    PublicName = '__location_public_name__',
    PagesSource = '__location_pages_source__',
    Search = '__location_search__',
    Uid = '__location_uid__',
    Id = '__location_id__',
    Code = '__location_code__',
    Web = '__location_web__',
    Source = 'source',
    StreetAddress = '__location_addr_street_address__',
    StreetAddress2 = '__location_addr_street_address2__',
    AddrLocality = '__location_addr_locality__',
    AddrRegion = '__location_addr_region__',
    AddrCountry = '__location_addr_country__',
    AddrPostalCode = '__location_addr_postal_code__',
    GroupCode = 'location.groupCode',
    TenantID = '__location_tenantID__',
    Type = 'location.type',
    Country = '__location_addr_country__',
    Region = '__location_addr_region__',
    Locality = '__location_addr_locality__',
    City = 'city',
    State = 'state',
}

export interface GetLocationsArgs {
    basic?: boolean;
}

export const getLocations = async (
    agencyId: number,
    tenantId: number,
    search?: SearchRequest,
    args?: GetLocationsArgs,
): Promise<Location[]> => {
    const params: any = {
        agencyId,
        tenantId,
        search,
        args,
    };

    const { data } = await axios.get(`/api/tenants/${tenantId}/r4e-locations`, { params });

    return data;
};

export const getAllLocations = async (
    agencyId: number,
    tenantId: number,
    search?: SearchRequest,
    args?: GetLocationsArgs,
): Promise<Location[]> => {
    const params: any = { agencyId, tenantId, search, args };

    const { data } = await axios.post(`/api/tenants/${tenantId}/r4e-all-locations`, params);

    return data;
};

export interface GetLocationArgs {
    id?: string;
    code?: string;
    key?: string;
}

export const getLocation = async (
    agencyId: number,
    tenantId: number,
    locationUid: string,
    args?: GetLocationArgs,
): Promise<Location> => {
    const params: any = { agencyId, tenantId, locationUid, args };

    const { data } = await axios.get(`/api/tenants/${tenantId}/r4e-locations/${locationUid}`, { params });

    return data;
};

export const getLocationData = async (tenantId: number, locationUid: string): Promise<Location> => {
    const { data } = await axios.get(`/api/tenants/${tenantId}/r4e-locations/${locationUid}`);

    return data;
};

export const saveLocation = async (agencyId: number, tenantId: number, location: Location): Promise<Location> => {
    const params: any = { agencyId, tenantId, location };

    const { data } = await axios.post(`/api/tenants/${tenantId}/r4e-locations`, params);

    return data;
};

export const countLocations = async (agencyId: number, tenantId: number, search: SearchRequest): Promise<any> => {
    const params: any = { agencyId, tenantId, search };

    const { data } = await axios.put(`/api/tenants/${tenantId}/r4e-locations/count`, params);

    return data;
};
